export default __webpack_public_path__ + "static/media/alli-mini-aentli.f8911385.pdf";